
document.addEventListener("DOMContentLoaded", function () {
    // Horizontal draggable slider
    const $horizontalTrack = document.querySelector(".video-keen-track");
    const $horizontalSlides = Array.from(document.querySelectorAll(".video-slide"));
  
    if (!$horizontalTrack || $horizontalSlides.length === 0) return;
  
    let isDown = false, startX = 0, startY = 0, currentTranslate = 0, prevTranslate = 0;
    let lastX = 0, lastY = 0, velocity = 0, isDragging = false;
  
    function getTrackWidth() {
      return $horizontalTrack.scrollWidth;
    }
    function getContainerWidth() {
      return $horizontalTrack.parentElement ? $horizontalTrack.parentElement.getBoundingClientRect().width : 0;
    }
  
    function setTranslate(x, withTransition = false) {
      $horizontalTrack.style.transition = withTransition ? "transform 0.4s ease-out" : "none";
  
      const trackWidth = getTrackWidth();
      const containerWidth = getContainerWidth();
      const minTranslate = -(trackWidth - containerWidth);
      const maxTranslate = 0;
  
      if (minTranslate >= 0) x = 0; // nothing to scroll
  
      if (x > maxTranslate) x = maxTranslate;
      if (x < minTranslate) x = minTranslate;
  
      currentTranslate = x;
      $horizontalTrack.style.transform = `translate3d(${x}px,0,0)`;
    }
  
    $horizontalSlides.forEach(slide => slide.style.cursor = "pointer");
  
    function getPoint(e) {
      if (e.touches && e.touches[0]) return { x: e.touches[0].pageX, y: e.touches[0].pageY };
      if (e.changedTouches && e.changedTouches[0]) return { x: e.changedTouches[0].pageX, y: e.changedTouches[0].pageY };
      return { x: e.pageX, y: e.pageY };
    }
  
    // Mousedown / Touchstart
    function startDrag(e) {
      isDown = true;
      isDragging = false;
  
      const p = getPoint(e);
      startX = p.x;
      startY = p.y;
      lastX = startX;
      lastY = startY;
      velocity = 0;
  
      $horizontalSlides.forEach(s => s.style.cursor = "grabbing");
      $horizontalTrack.style.transition = "none";
  
      // e.preventDefault();  // This is preventing the openPopupFromSlide
    }
  
    $horizontalSlides.forEach(slide => {
      slide.addEventListener("mousedown", startDrag);
      slide.addEventListener("touchstart", startDrag, { passive: false });
    });
  
    // Mousemove / Touchmove
    function moveDrag(e) {
      if (!isDown) return;
  
      const p = getPoint(e);
      const x = p.x;
      const y = p.y;
      const deltaX = x - startX;
      const deltaY = y - startY;
  
      // Drag threshold (mobile friendly)
      const DRAG_THRESHOLD = ("ontouchstart" in window) ? 10 : 5;
      if (Math.abs(deltaX) > DRAG_THRESHOLD || Math.abs(deltaY) > DRAG_THRESHOLD) {
        isDragging = true;
      }
  
      setTranslate(prevTranslate + deltaX);
  
      velocity = x - lastX;
      lastX = x;
      lastY = y;
  
      e.preventDefault?.();
    }
  
    document.addEventListener("mousemove", moveDrag);
    document.addEventListener("touchmove", moveDrag, { passive: false });
  
    function endDrag() {
      if (!isDown) return;
      isDown = false;
  
      const momentum = velocity * 20;
      setTranslate(currentTranslate + momentum, true);
      prevTranslate = currentTranslate;
  
      $horizontalSlides.forEach(s => s.style.cursor = "pointer");
    }
  
    ["mouseup", "touchend", "touchcancel", "mouseleave"].forEach(evt => {
      document.addEventListener(evt, endDrag);
    });
  
    // Vertical thumbnail + main videos
    const $container = document.querySelector(".left_video_thumbnail");
    const $view = $container ? $container.querySelector(".thumb_view") : null;
    const $verticalTrack = $container ? $container.querySelector(".thumb_track") : null;
    const $items = $container ? Array.from($container.querySelectorAll(".thumb_item")) : [];
    const $prev = $container ? $container.querySelector(".thumb_btn.prev") : null;
    const $next = $container ? $container.querySelector(".thumb_btn.next") : null;
  
    const $mainWrapper = document.querySelector(".popup_main_video_wrapper");
    const $mainVideos = $mainWrapper ? Array.from($mainWrapper.querySelectorAll(".main_video")) : [];
  
    let currentIndex = 0;
    let allMuted = false;
  
    function outerHeight(el) {
      if (!el) return 0;
      return el.getBoundingClientRect().height;
    }
  
    function updateSlider() {
      if (!$view || !$verticalTrack || $items.length === 0 || $mainVideos.length === 0) return;
  
      const GAP = 15;
      const VISIBLE_COUNT = 3;
  
      const itemHeight = outerHeight($items[0]) + GAP;
      const viewHeight = outerHeight($view);
      const trackHeight = $items.length * itemHeight;
      const maxTranslate = Math.max(trackHeight - viewHeight, 0);
  
      // Vertical thumbnail track scroll
      let translateY = currentIndex * itemHeight - (itemHeight * Math.floor(VISIBLE_COUNT / 2));
      translateY = Math.max(0, Math.min(translateY, maxTranslate));
      $verticalTrack.style.transform = `translateY(-${translateY}px)`;
  
      // Thumbnail active state
      $items.forEach((item, idx) => {
        item.style.border = "2px solid transparent";
        item.style.opacity = "0.5";
        if (idx === currentIndex) {
          item.style.border = "2px solid #fff";
          item.style.opacity = "1";
        }
      });
  
      if ($prev) $prev.classList.toggle("is-hidden", currentIndex === 0);
      if ($next) $next.classList.toggle("is-hidden", currentIndex === $items.length - 1);
  
      const popup = document.querySelector("#video-popup");

      // Main videos play/pause + mute
      $mainVideos.forEach((wrap, index) => {
        const video = wrap.querySelector("video");
        const btn = wrap.querySelector(".autoplay_button");

        if (index === currentIndex) {
          wrap.classList.add("active");
          wrap.style.display = "";

          if (video) {
            video.muted = allMuted ? true : false;
            if (popup.classList.contains("popup-open")) {
              video.play().catch(() => {});
            }
          }
          if (btn) btn.style.display = "none";
        } else {
          wrap.classList.remove("active");
          wrap.style.display = "none";

          if (video) {
            video.pause();
            video.currentTime = 0;
            video.muted = true;
            if (btn) btn.style.display = "";
          }
        }
      });
  
      // Sidebar products
      const $products = Array.from(document.querySelectorAll(".product_sidebar .collection-products"));
      if ($products.length) {
        $products.forEach(p => p.style.display = "none");
        if ($products[currentIndex]) $products[currentIndex].style.display = "";
      }
  
      // Scroll main wrapper
      let scrollPos;
      if (window.innerWidth < 768) {
        const mainVideoHeight = ($mainVideos[currentIndex] && outerHeight($mainVideos[currentIndex])) || window.innerHeight * 1.1;
        scrollPos = currentIndex * mainVideoHeight;
      } else {
        scrollPos = currentIndex * window.innerHeight;
      }
  
      $mainWrapper?.scrollTo({ top: scrollPos, behavior: "smooth" });
    }
  
    updateSlider();
  
    function indexOfItem(el, list) {
      return list.indexOf(el);
    }
  
    $items.forEach(item => {
      item.addEventListener("click", function () {
        currentIndex = indexOfItem(this, $items);
        updateSlider();
      });
    });
  
    $next?.addEventListener("click", function () {
      if (currentIndex < $items.length - 1) {
        currentIndex++;
        updateSlider();
      }
    });
  
    $prev?.addEventListener("click", function () {
      if (currentIndex > 0) {
        currentIndex--;
        updateSlider();
      }
    });
  
    function wheelHandler(e) {
      e.preventDefault();
      if (e.deltaY > 0 && currentIndex < $items.length - 1) currentIndex++;
      else if (e.deltaY < 0 && currentIndex > 0) currentIndex--;
      updateSlider();
    }
  
    $container?.addEventListener("wheel", wheelHandler, { passive: false });
    $mainWrapper?.addEventListener("wheel", wheelHandler, { passive: false });
  
    $mainVideos.forEach(wrap => {
      const video = wrap.querySelector("video");
      const btn = wrap.querySelector(".autoplay_button");
      if (!video) return;
  
      wrap.addEventListener("click", function () {
        if (video.paused) { video.play().catch(() => {}); if (btn) btn.style.display = "none"; }
        else { video.pause(); if (btn) btn.style.display = ""; }
      });
  
      btn?.addEventListener("click", function (e) {
        e.stopPropagation();
        if (video.paused) { video.play().catch(() => {}); btn.style.display = "none"; }
        else { video.pause(); btn.style.display = ""; }
      });
    });
  
    document.querySelector(".speacker_button")?.addEventListener("click", function () {
      allMuted = !allMuted;
  
      $mainVideos.forEach((wrap, index) => {
        const video = wrap.querySelector("video");
        if (!video) return;
        video.muted = allMuted || index !== currentIndex;
      });
  
      const muteIcon = document.querySelector(".mute_icon");
      const speakerIcon = document.querySelector(".speaker_icon");
      if (muteIcon) muteIcon.style.display = allMuted ? "block" : "none";
      if (speakerIcon) speakerIcon.style.display = allMuted ? "none" : "";
    });
  
    // Horizontal video slide click → popup + vertical active
    const popup = document.querySelector("#video-popup");
    const closePopup = document.querySelector("#close-popup");
      
    function openPopupFromSlide(slideEl) {
      if (isDragging) return;

      const videoEl = slideEl.querySelector("video");
      const imageEl = slideEl.querySelector("img");

      if (!videoEl && !imageEl) return;
      if (popup) {
        popup.classList.add("popup-open")
      }

      // Sync vertical/main
      const clickedIndex = indexOfItem(slideEl, $horizontalSlides);
      if (clickedIndex >= 0 && clickedIndex < $mainVideos.length) {
        currentIndex = clickedIndex;
        updateSlider();
      }

      if (popup) { 
        popup.style.display = "block";
      }
      document.body.style.overflow = "hidden";
    }

    // Use click only (touchend can double-fire)
    $horizontalSlides.forEach(slide => {
      slide.addEventListener("click", function () {
        openPopupFromSlide(this);
      });
    });
  
    // Close popup
    closePopup?.addEventListener("click", function () {
      if (popup) { 
        popup.style.display = "none";
        popup.classList.remove("popup-open")
      }
      document.body.style.overflow = "";
  
      $mainVideos.forEach(wrap => {
        const video = wrap.querySelector("video");
        const btn = wrap.querySelector(".autoplay_button");
        if (!video) return;
        video.pause();
        video.currentTime = 0;
        video.muted = true;
        wrap.classList.remove("active");
        if (btn) btn.style.display = "";
      });
  
      currentIndex = 0;
      $items.forEach(it => { it.style.border = "2px solid transparent"; });
      if ($items[0]) $items[0].style.border = "2px solid #fff";
      if ($verticalTrack) $verticalTrack.style.transform = "translateY(0)";
      $mainWrapper?.scrollTo({ top: 0, behavior: "smooth" });
    });
  
    // Mobile swipe vertical
    if (window.innerWidth < 768) {
      let touchStartY = 0;
      let touchEndY = 0;
      let isDraggingVertically = false;
  
      const swipeTargets = [
        document.querySelector(".left_video_thumbnail"),
        document.querySelector(".popup_main_video_wrapper"),
      ].filter(Boolean);
  
      swipeTargets.forEach(target => {
        target.addEventListener("touchstart", function (e) {
          touchStartY = e.touches[0].clientY;
          isDraggingVertically = false;
        }, { passive: true });
  
        target.addEventListener("touchmove", function (e) {
          touchEndY = e.touches[0].clientY;
          const diff = touchStartY - touchEndY;
          const DRAG_THRESHOLD = 15;
          if (Math.abs(diff) > DRAG_THRESHOLD) isDraggingVertically = true;
        }, { passive: true });
  
        target.addEventListener("touchend", function () {
          if (!isDraggingVertically) return;
  
          const diff = touchStartY - touchEndY;
          const SWIPE_THRESHOLD = 50;
  
          if (diff > SWIPE_THRESHOLD && currentIndex < $items.length - 1) {
            currentIndex++;
            updateSlider();
          } else if (diff < -SWIPE_THRESHOLD && currentIndex > 0) {
            currentIndex--;
            updateSlider();
          }
        }, { passive: true });
      });
    }
  });
  
  
  
  /* ============================================================
    Mobile Video popup (view all products click then sidebar products show)
  =============================================================== */
  document.addEventListener("DOMContentLoaded", function () {
    const viewButtons = document.querySelectorAll(".view_popup_products");
    const productSidebar = document.querySelector(".product_sidebar");
    const closeIcon = document.querySelector(".close_icon");
  
    // Open sidebar
    viewButtons.forEach((button) => {
      button.addEventListener("click", function () {
        if (productSidebar) productSidebar.classList.add("active");
      });
    });
  
    // Close sidebar
    if (closeIcon) {
      closeIcon.addEventListener("click", function () {
        if (productSidebar) productSidebar.classList.remove("active");
      });
    }
  });
  
  
  /* ============================================================
    Popup featured product click to add to cart drawer open (mobile)
  =============================================================== */
  document.addEventListener("DOMContentLoaded", function () {
    const triggers = document.querySelectorAll(".popup_single_product, .sort_add_to_cart");
  
    triggers.forEach((el) => {
      el.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
  
        const drawerId = el.getAttribute("data-drawer");
        if (!drawerId) return;
  
        // Close all drawers
        document.querySelectorAll(".drawer_modal").forEach((d) => d.classList.remove("active"));
  
        // Open matching drawer
        const target = document.getElementById(drawerId);
        if (target) target.classList.add("active");
  
        document.body.classList.add("drawer-open");
      });
    });
  });
  

  
  /* ============================================================
    Drawer double Popup Product image slider
  =============================================================== */
  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".drawer_slider").forEach((slider) => {
      const prev = slider.querySelector(".slider_arrow.prev");
      const next = slider.querySelector(".slider_arrow.next");
      if (prev) prev.style.display = "none";
      if (next) next.style.display = "";
    });
  });
  
  // Event delegation for arrows (works for dynamically-added drawers too)
  document.addEventListener("click", function (e) {
    const arrow = e.target.closest(".slider_arrow");
    if (!arrow) return;
  
    const slider = arrow.closest(".drawer_slider");
    if (!slider) return;
  
    const track = slider.querySelector(".slider_track");
    const view = slider.querySelector(".slider_view");
    if (!track || !view) return;
  
    let currentPos = parseInt(slider.getAttribute("data-pos") || "0", 10) || 0;
    const maxScroll = Math.max(track.scrollWidth - view.getBoundingClientRect().width, 0);
  
    if (arrow.classList.contains("next")) currentPos += 150;
    else currentPos -= 150;
  
    if (currentPos < 0) currentPos = 0;
    if (currentPos > maxScroll) currentPos = maxScroll;
  
    slider.setAttribute("data-pos", String(currentPos));
    track.style.transform = `translateX(-${currentPos}px)`;
  
    const prev = slider.querySelector(".slider_arrow.prev");
    const next = slider.querySelector(".slider_arrow.next");
    if (prev) prev.style.display = currentPos > 0 ? "" : "none";
    if (next) next.style.display = currentPos < maxScroll ? "" : "none";
  });
  
  
  /* ============================================================
    Add to cart drawer open
  =============================================================== */
  document.addEventListener("DOMContentLoaded", function () {
    // OPEN drawer: product-item OR shop_now_btn
    document.querySelectorAll(".product-item, .shop_now_btn").forEach((el) => {
      el.addEventListener("click", function (e) {
        e.stopPropagation();
  
        // Match original logic: find closest .product-item and read its data-handle
        const productItem = el.closest(".product-item");
        const handle = productItem ? productItem.getAttribute("data-handle") : null;
        if (!handle) return;
  
        document.querySelectorAll(".drawer_modal").forEach((d) => d.classList.remove("active"));
  
        const drawer = document.getElementById("drawer-" + handle);
        if (drawer) drawer.classList.add("active");
  
        document.body.classList.add("drawer-open");
      });
    });
  
    // CLOSE drawer: only close button (delegation)
    document.addEventListener("click", function (e) {
      const closeBtn = e.target.closest("#close_modal");
      if (!closeBtn) return;
  
      e.stopPropagation();
  
      const modal = closeBtn.closest(".drawer_modal");
      if (modal) modal.classList.remove("active");
  
      document.body.classList.remove("drawer-open");
    });
  });
  
  
  /* ============================================================
    Popup Drawer accordion collapse
  =============================================================== */
  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".popup_product_accordian").forEach((acc) => {
      acc.addEventListener("click", function () {
        acc.classList.toggle("active");
      });
    });
  });
  
  
  /* ============================================================
    Quantity Input js
  =============================================================== */
  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".drawer_qty_wrapper").forEach((wrapper) => {
      const input = wrapper.querySelector(".drawer_qty");
      const minus = wrapper.querySelector(".minus");
      const plus = wrapper.querySelector(".plus");
  
      if (!input) return;
  
      const getVal = () => Math.max(parseInt(input.value || "1", 10) || 1, 1);
      const setVal = (v) => { input.value = String(Math.max(v, 1)); };
  
      if (minus) {
        minus.addEventListener("click", function () {
          const value = getVal();
          if (value > 1) setVal(value - 1);
        });
      }
  
      if (plus) {
        plus.addEventListener("click", function () {
          const value = getVal();
          setVal(value + 1);
        });
      }
  
      // Prevent negative input manually
      input.addEventListener("input", function () {
        setVal(getVal());
      });
    });
  });
  
  
  document.addEventListener('DOMContentLoaded', function() {
    const addToCartBtns = document.querySelectorAll('.drawer_addtocart');
  
    addToCartBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        const drawer = this.closest('.drawer_inner');
        const variantSelect = drawer.querySelector('.drawer_variant');
        const qtyInput = drawer.querySelector('.drawer_qty');
  
     
        let variantId = this.dataset.id;
        if(variantSelect && variantSelect.value) {
          variantId = variantSelect.value;
        }
  
        const quantity = qtyInput ? parseInt(qtyInput.value) : 1;
        if(!variantId || quantity < 1) return;
  
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            id: variantId,
            quantity: quantity
          })
        })
        .then(response => response.json())
        .then(data => {
          window.location.href = `/products/${data.handle}`;
        })
        .catch(err => {
          console.error('Add to cart error:', err);
        });
      });
    });
  });